import { render } from "./companion.vue?vue&type=template&id=6a976afa&scoped=true"
import script from "./companion.vue?vue&type=script&lang=js"
export * from "./companion.vue?vue&type=script&lang=js"

import "./companion.vue?vue&type=style&index=0&id=6a976afa&scoped=true&lang=css"
import "./companion.vue?vue&type=style&index=1&id=6a976afa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a976afa"]])

export default __exports__